export const LOGIN = "LOGIN"
export const REDIRECT_URL = "REDIRECT_URL"
export const USERINFO_THROW_ERROR = "USERINFO_THROW_ERROR"
export const SMALL_DEVICE = "SMALL_DEVICE"
export const LANGUAGE = "LANGUAGE"
